import React from "react";
import clsx from "clsx";

import ValidIcon from "@material-ui/icons/CheckCircle";
import InvalidIcon from "@material-ui/icons/Warning";

import useStyles from "./styles";

interface IProps {
  hasError: boolean;
  className?: string;
  errorText?: string;
  withIcon?: boolean;
}

const FormSectionValidationResult = (props: IProps) => {
  const { errorText, hasError, withIcon = false, className } = props;
  const shouldShowErrorText = Boolean(errorText && hasError);

  const classes = useStyles();

  const validationResultIcon = hasError ? (
    <InvalidIcon className={clsx(classes.sectionValidIcon, classes.invalid)} />
  ) : (
    <ValidIcon className={clsx(classes.sectionValidIcon, classes.valid)} />
  );

  return (
    <div className={clsx(classes.container, { withIndention: withIcon })}>
      {withIcon && <div>{validationResultIcon}</div>}
      {shouldShowErrorText && (
        <div
          className={clsx(className, classes.errorText, {
            withIndention: withIcon
          })}
        >
          {errorText}
        </div>
      )}
    </div>
  );
};

export default React.memo(FormSectionValidationResult);
